import React from 'react'
import { useTranslation } from 'react-i18next'

import { AddressSourceType } from '@makyoapp/makyo-common'
import { PlusCode16, SignPost24 } from '@makyoapp/makyo-icon/icon'
import { SingleIconSelect } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { Fld, Lbl } from './shared'

interface AddressListOption {
  /**
   * html ID
   */
  id: AddressSourceType
  /**
   * the icon
   */
  icon: () => React.ReactNode
  /**
   * title
   */
  title: string
}

/**
 * handle create column address options field
 */
export default function FieldAddress() {
  const { t } = useTranslation()
  const { id, value, setValue } = useCreateColumnContext()
  return (
    <Fld>
      <Lbl>{t('Type')}</Lbl>
      <SingleIconSelect
        id={`${id}-adr-type`}
        onClick={(opt) => {
          setValue({
            addressOptions: {
              adrType: opt.id as AddressSourceType,
            },
          })
        }}
        options={
          [
            {
              id: 'street',
              icon: () => <SignPost24 width={24} height={24} />,
              title: t('Street Address'),
            },
            /*{
              id: 'coordinate',
              icon: () => <Routing24 width={24} height={24} />,
              title: t('Coordinate')
            },*/
            {
              id: 'plus-code',
              icon: () => <PlusCode16 width={24} height={24} />,
              title: t('Plus Code'),
            },
          ] as Array<AddressListOption>
        }
        selected={value.addressOptions.adrType}
      />
    </Fld>
  )
}
